module.exports = __webpack_public_path__ + "img/classroom-disabled.ffdb75a4.gif";